module.exports = __webpack_public_path__ + "fonts/Inter-300-greek-ext17.318d4ba.woff2";